/* ARTMiE — hero kampaní, koncept E.
 *
 * Čo je tu zámerne inak než v náhľade:
 *   • žiadny setInterval na pozadí — prepínanie beží na setTimeout a ten sa RUŠÍ,
 *     keď sekcia nie je vidieť alebo keď je karta na pozadí. Kým hero nikto nevidí,
 *     stránka nerobí vôbec nič. Myš nad bannerom prepínanie NEZASTAVUJE.
 *   • plnenie ukazovateľa je CSS animácia, pauzuje sa cez animation-play-state,
 *     takže sa nepočíta žiadny čas v JS.
 *   • prefers-reduced-motion vypne automatické prepínanie úplne.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.aheReady === '1') return;
    root.dataset.aheReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.ahe-slide'));
    // KAŽDÝ slide nesie vlastnú sadu ukazovateľov (3 kampane = 3 sady po 3). Keby sme ich
    // brali ako jeden plochý zoznam, „bežiaci" ukazovateľ by pri druhej kampani patril
    // skrytému slidu a na obrazovke by sa nehýbalo nič.
    var barGroups = slides.map(function (s) {
      return Array.prototype.slice.call(s.querySelectorAll('.ahe-bars button'));
    });
    var dur = parseInt(root.dataset.aheDur, 10) || 6000;
    if (slides.length < 2) { paintBars(0); return; }

    var i = 0;             // ktorý slide je práve na rade
    var timer = null;      // beží iba keď je čo počítať
    var left = dur;        // koľko z intervalu ešte zostáva
    var startedAt = 0;
    var visible = true;

    /* ---- vykreslenie ---- */
    function paintBars(n) {
      barGroups.forEach(function (group) {
        group.forEach(function (b, k) {
          var f = b.querySelector('i');
          b.classList.toggle('is-done', k < n);
          b.classList.remove('is-live');
          // Inline pauza z predchádzajúceho zastavenia sa MUSÍ zmazať, inak by nový
          // ukazovateľ nastúpil rovno zamrznutý.
          if (f) f.style.animationPlayState = '';
          if (k === n) {
            if (f) void f.offsetWidth; // vynútený reflow reštartuje CSS animáciu
            b.classList.add('is-live');
          }
        });
      });
    }

    function show(n, instant) {
      var prev = slides[i];
      i = (n + slides.length) % slides.length;
      var next = slides[i];
      if (prev === next) return;

      if (instant) {
        slides.forEach(function (s) { s.classList.remove('is-on'); });
        next.classList.add('is-on');
      } else {
        // obsah sa nevymení skokom — najprv odsunie, potom nabehne nový
        var txt = prev.querySelector('.ahe-txt');
        var flo = prev.querySelector('.ahe-float');
        if (txt) txt.classList.add('is-swap');
        if (flo) flo.classList.add('is-swap');
        setTimeout(function () {
          slides.forEach(function (s) { s.classList.remove('is-on'); });
          next.classList.add('is-on');
          if (txt) txt.classList.remove('is-swap');
          if (flo) flo.classList.remove('is-swap');
        }, 280);
      }
      paintBars(i);
      restart();
    }

    /* ---- beh času ---- */
    function barsPlay(on) {
      barGroups.forEach(function (group) {
        group.forEach(function (b) {
          var f = b.querySelector('i');
          if (f) f.style.animationPlayState = on ? 'running' : 'paused';
        });
      });
    }

    function play() {
      // myš nad bannerom prepínanie NEZASTAVUJE — kampane sa striedajú ďalej
      if (REDUCED || timer || !visible || document.hidden) return;
      startedAt = Date.now();
      barsPlay(true);
      timer = setTimeout(function () { timer = null; left = dur; show(i + 1); }, left);
    }

    function pause() {
      if (!timer) return;
      clearTimeout(timer); timer = null;
      left = Math.max(300, left - (Date.now() - startedAt));
      barsPlay(false);
    }

    function restart() { pause(); left = dur; play(); }

    /* ---- ovládanie ---- */
    barGroups.forEach(function (group) {
      group.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    });
    root.querySelectorAll('[data-ahe-prev]').forEach(function (b) {
      b.addEventListener('click', function () { show(i - 1); });
    });
    root.querySelectorAll('[data-ahe-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(i + 1); });
    });

    // potiahnutie prstom — ale nie vtedy, keď zákazník posúva rad kapsúl
    var x0 = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('.ahe-stack')) { x0 = null; return; }
      x0 = e.clientX;
    }, { passive: true });
    root.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var d = e.clientX - x0; x0 = null;
      if (Math.abs(d) > 45) show(i + (d < 0 ? 1 : -1));
    }, { passive: true });
    // gesto, ktoré si prehliadač vzal pre seba, nesmie nechať za sebou rozrobený stav
    root.addEventListener('pointercancel', function () { x0 = null; }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause(); else play();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (x) { visible = x.isIntersecting; if (visible) play(); else pause(); });
      }, { threshold: 0.15 }).observe(root);
    }

    paintBars(0);
    play();
  }

  function boot() {
    document.querySelectorAll('.ahe').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // editor tém prekresľuje sekcie za behu
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
